"use strict";
/*
 * Created on 05/12/2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 *
 * @author JMr
 */


var PriceCommentSaveRequestConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PriceCommentSaveRequestConverter, _DataObjectConverter_);

  function PriceCommentSaveRequestConverter() {
    _classCallCheck(this, PriceCommentSaveRequestConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceCommentSaveRequestConverter).apply(this, arguments));
  }

  return PriceCommentSaveRequestConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PriceCommentSaveRequestConverter = PriceCommentSaveRequestConverter;